import { useRef, useState } from "react";

export default function Filter({ records, search }) {
  const searchRef = useRef();

  const [searchuser, setSearchUser] = useState("");

  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {records}
        </button>
      </div>
      <div className="filterright">
        <div className="margin-right">
          <input
            ref={searchRef}
            type="text"
            name="search"
            id="search"
            autoComplete="new-password"
            placeholder="Search Bank Account"
            class="input bg-[var(--background)] border-2 h-7 border-[var(--hover)] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white "
            value={searchuser}
            onChange={(e) => {
              setSearchUser(e.target.value);
              search(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
}
